module.exports = __webpack_public_path__ + "media/bootstrap-icons/cursor-text-e35db275.svg";